<template>
  <div>
    <form v-loading="loading" @submit.prevent="validatePinCode">
      <h1 class="title">{{ $t('settings.catering.pinCodeHeader') }}</h1>
      <div class="main-settings">
        <div class="settings-section">
          <h2 class="sub-title">{{ $t('settings.catering.pinCodeLabel') }}</h2>
          <el-input
            :value="userPinCode"
            :controls="false"
            :placeholder="$t('settings.catering.pinCodePH')"
            type="password"
            @input="onInput"
            class="settings-password"
          >
          </el-input>
        </div>
        <common-button primary type="submit" @submit="validatePinCode">{{
          $t('settings.catering.pinCodeSubmit')
        }}</common-button>
      </div>
    </form>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import CommonButton from '@/components/common/CommonButton';

export default {
  name: 'PinCodeKeyboard',
  components: {
    CommonButton,
  },
  data() {
    return {
      userPinCode: '',
      loading: true,
    };
  },
  async created() {
    if (this.pinCode === null) {
      await this.getPinCode();
    }
    this.loading = false;
  },
  methods: {
    ...mapActions('catering', {
      getPinCode: 'getRemotePinCode',
    }),
    validatePinCode(e) {
      e.preventDefault();
      if (this.userPinCode !== this.pinCode) {
        this.$alert(this.$t('settings.messages.incorrectPinCode'));
      } else {
        this.$emit('validPinCode', true);
      }
    },
    onInput(val) {
      if (val.length < 5) {
        this.userPinCode = val;
      } else {
        this.userPinCode = '';
        // Followings comment are part of a bug. Dismiss
        // const prev = this.userPinCode;
        // this.userPinCode = prev;
      }
    },
  },

  computed: {
    ...mapState('catering', { pinCode: (state) => state.catering.pinCode }),
  },
};
</script>

<style scoped lang="scss">
@import '../../scss/variables';

.main-settings {
  margin-top: 5px;
  text-align: center;
  width: auto;
}
.settings-section {
  padding-top: 5px;
  padding-bottom: 30px;
}
.settings-password {
  max-width: 200px;
}
.save-button {
  padding: 20px;
}
.title {
  margin-left: 15px;
  font-weight: $bold-font;
  font-size: $title-font-size;
  text-align: center;
}
.sub-title {
  font-weight: $bold-font;
}
.title,
.sub-title {
  margin: 20px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/catering/PinCodeKeyboard.vue